<template>
  <div>
    <div class="bg-white padding" style="position: relative; z-index: 2" ref="card" v-show="medicalInformationList.length>0">
      <div class="input-item flex">
        <div style="display: flex">
          <div class="line"></div>
          <span class="text-nowrap">已綁定的就診資訊</span>
        </div>
        <div>
          <span style="font-size: 16px" class="text-blue" @click="changeModifyListStatus">{{ isListInModify ? '完成' : '編輯' }}</span>
        </div>
      </div>
      <div class="dark-card">
        <div v-for="(item, i) in medicalInformationList" :key="i" class="flex border">
          <div>
            <div>聯合醫院 {{ item.branch }}院區</div>
            <div style="font-size: 14px; color: #c7c7c7">{{ item.id_card_number.slice(0, 1) }}*****{{ item.id_card_number.slice(6, 10) }}</div>
          </div>
          <div class="delete" v-if="isListInModify" @click="removeFavoriteMedicalInformation(item.medical_information_serial_number)"></div>
          <div class="active" v-else @click="getBillIsNull(false, item.id_card_number, item.birthday, formatBranchNameToBranchCode(item.branch))">查詢</div>
        </div>
      </div>
    </div>
    <div class="bg-white padding">
      <div class="input-item flex">
        <div style="display: flex; align-items: center" class="text-nowrap">
          <div class="line"></div>
          {{ medicalInformationList.length>0 ? '查詢其他就診資訊' : '請輸入就診資訊' }}
        </div>
        <div class="icon-scan" @click="openScanner()">掃描</div>
      </div>
      <div class="form">
        <div>
          <div class="field">
            <span class="required">*</span>
            醫院院別
          </div>
          <select name="branch" v-model="form.branch" @focus="branchInFocus = true" @blur="branchInFocus = false">
            <option v-for="branch in branchList" :value="branch.value" :key="branch.value">聯合醫院 {{ branch.name }}院區</option>
          </select>
          <div class="border-bottom" :style="branchBorderStyle"></div>
        </div>
        <div>
          <div class="field">
            <span class="required">*</span>
            身分證字號
          </div>
          <input type="text" name="id_card_number" placeholder="輸入身分證字號" class="input" v-model="userId" @focus="idInFocus = true" @keyup="changeIDNumber" @blur="idInFocus = false" />
          <div class="border-bottom" :style="idBorderStyle"></div>
          <div class="required" v-if="!isUserIdVerified">身分證填寫錯誤！</div>
        </div>
        <div>
          <div class="field">
            <span class="required">*</span>
            生日
          </div>
          <input type="date" name="birthday" placeholder="選擇生日" class="select" v-model="form.birthday" :max="today" :min="minBirthday" @focus="birthdayInFocus = true" @blur="birthdayInFocus = false" />
          <div class="border-bottom" :style="birthdayBorderStyle"></div>
        </div>
        <!-- <div class="agree-label" style="margin-bottom: 16pt">
                    <input type="checkbox" id="isAddFavroriteChecked" v-model="isAddFavroriteChecked">
                    <label for="isAddFavroriteChecked">綁定資料，以便日後快速查詢待繳醫療費用</label>
                </div>-->
      </div>
      <button class="btn btn-primary" :disabled="isSearchBtnDisable" ref="search_btn" @click="addFavoriteMedicalInformation">查詢待繳帳單</button>
    </div>
    <div class="padding description">
      <ul class="text-gray2">
        <li>輸入就診資料後，即可快速查詢待繳醫療費用。</li>
        <li>可使用悠遊付錢包、銀行帳戶連結、信用卡(<span class="text-blue">限台新銀行、玉山銀行發卡</span>)進行繳費扣款。</li>
        <li>如已在醫院或其他繳費平台繳費，請勿重複繳納。</li>
        <li>逾繳費期限之醫療費，將不提供查詢繳費功能。</li>
        <li>如有退費相關事宜，請洽就診醫院辦理。</li>
        <li>僅提供市立聯合醫院看診當日(23:00前)，門診醫療費用查繳，查無資料請洽櫃檯繳費。</li>
      </ul>
    </div>
    <div :class="isListInModify ? 'mask' : ''" ref="mask"></div>
  </div>
</template>

<script>
import { checkID } from '../../utils/verify-id';
import { queryFavoriteMedicalInformation, saveFavoriteMedicalInformation, deleteFavoriteMedicalInformation, queryBillList } from '../../api/api';
import { branch_list, formatBranchNameToBranchCode } from '../../utils/branch-list';
import { mapActions } from 'vuex';

export default {
  name: 'medical-fee-list',
  data() {
    return {
      medicalInformationList: [],
      isListInModify: false,
      form: {
        branch: 'G',
        idCardNumber: '',
        birthday: '',
      },
      isAddFavroriteChecked: false,
      isUserIdVerified: true,
      branchList: branch_list,
      branchInFocus: false,
      birthdayInFocus: false,
      idInFocus: false,
    };
  },
  created() {
    this.getFavoriteMedicalInformation();
    window.getScanningResult = this.getScanningResult;
    this.defaultBirthday();
  },
  computed: {
    isSearchBtnDisable() {
      return this.form.branch == null || this.form.idCardNumber === '' || !this.isUserIdVerified || this.form.birthday === '';
    },
    userId: {
      get: function () {
        return this.form.idCardNumber;
      },
      set: function (val) {
        this.form.idCardNumber = val.toUpperCase();
      },
    },
    today() {
      return new Date().toJSON().split('T')[0];
    },
    minBirthday() {
      return new Date().getFullYear() - 120 + '-01-01';
    },
    branchBorderStyle() {
      return this.branchInFocus ? 'background: #007ac8' : 'background: #c7c7c7';
    },
    idBorderStyle() {
      if (this.idInFocus) {
        return 'background: #007ac8';
      } else if (!this.isUserIdVerified) {
        return 'background: #da2626';
      } else {
        return 'background: #c7c7c7';
      }
    },
    birthdayBorderStyle() {
      return this.birthdayInFocus ? 'background: #007ac8;margin-bottom:20pt' : 'background: #c7c7c7;margin-bottom:20pt';
    },
  },
  methods: {
    ...mapActions(['setReadyToPayBill']),
    getFavoriteMedicalInformation() {
      queryFavoriteMedicalInformation().then((res) => {
        if (res.error === null) {
          this.medicalInformationList = res.medical_information_list;
          setTimeout(() => {
            var height = this.$refs.card.clientHeight;
            this.$refs.mask.style.top = height + 'px';
          }, 1000);
        }
      });
    },
    changeModifyListStatus() {
      this.isListInModify = !this.isListInModify;
    },
    verifyUserId() {
      this.isUserIdVerified = checkID(this.form.idCardNumber);
    },
    formatBranchNameToBranchCode(branchName) {
      return formatBranchNameToBranchCode(branchName);
    },
    addFavoriteMedicalInformation() {
      var form = {
        branch: this.form.branch,
        id_card_number: this.form.idCardNumber,
        birthday: this.formatBirthday(this.form.birthday),
      };
      if (this.isAddFavroriteChecked) {
        saveFavoriteMedicalInformation(form).then((res) => {
          if (res.error !== null) {
            alert(res.error.message);
          } else {
            this.getBillIsNull(false, form.id_card_number, form.birthday, form.branch);
          }
        });
      } else {
        this.getBillIsNull(false, form.id_card_number, form.birthday, form.branch);
      }
    },
    formatBirthday(birthday) {
      return birthday.split('-')[0] + birthday.split('-')[1] + birthday.split('-')[2];
    },
    searchBill(idCardNumber, birthday, branch) {
      this.$router.push({
        path: '/goPay',
        query: {
          payment_item_id: 3,
          parameter1: idCardNumber,
          parameter2: birthday,
          parameter3: branch,
          payment_query_type: 1,
        },
      });
    },
    getBillIsNull(isScanning, idCardNumber, birthday, branch) {
      var form = {
        payment_item_id: 3,
        payment_query_type: isScanning ? 2 : 1,
        parameter1: idCardNumber,
        parameter2: birthday.slice(0, 4) + '/' + birthday.slice(4, 6) + '/' + birthday.slice(6, 8),
        parameter3: branch,
        payment_custom_id: isScanning ? idCardNumber : '',
      };
      queryBillList(form).then((res) => {
        if (res.error == null) {
          this.setReadyToPayBill(res);
          if (isScanning) {
            this.$router.push({
              path: '/goPay',
              query: {
                payment_item_id: 3,
                payment_custom_id: idCardNumber,
                payment_query_type: 2,
              },
            });
          } else {
            this.searchBill(idCardNumber, birthday, branch);
          }
        } else {
          alert(res.error.message);
        }
        if (this.isAddFavroriteChecked) {
          this.getFavoriteMedicalInformation();
        }
      });
    },
    removeFavoriteMedicalInformation(medicalInformationSerialNumber) {
      if (confirm('確定要刪除？')) {
        deleteFavoriteMedicalInformation({ medical_information_serial_number: medicalInformationSerialNumber }).then((res) => {
          if (res.error === null) {
            this.isListInModify = false;
            this.getFavoriteMedicalInformation();
          } else {
            alert(res.error.message);
          }
        });
      }
    },
    openScanner() {
      this.$store.dispatch('sentApp', {
        action: 'openScanner',
        payload: { type: 1 },
      });
    },
    getScanningResult(paymentCustomId) {
      this.$router.push({
        path: '/goPay',
        query: { payment_item_id: 3, payment_custom_id: paymentCustomId, payment_query_type: 2 },
      });
    },
    defaultBirthday() {
      let today = new Date();
      let year = today.getFullYear();
      let month = today.getMonth() + 1 < 10 ? '0' + (today.getMonth() + 1) : today.getMonth() + 1;
      let day = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
      this.form.birthday = year - 20 + '-' + month + '-' + day;
    },
    changeIDNumber(e) {
      e.target.value = e.target.value.replace(/[\W]/g, '');
      if (e.target.value.length >= 10) {
        e.target.blur();
      }
    },
  },
  watch: {
    userId() {
      this.verifyUserId();
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.border {
  border-bottom: 1px solid rgba(64, 64, 64, 0.75);
  padding: 9pt 0;
}

.field {
  font-size: 14px;
}

.form {
  margin: 24pt 0;
}

.border-bottom {
  margin-bottom: 24pt;
}
</style>
